import { render, staticRenderFns } from "./HistoryDetailDialog.vue?vue&type=template&id=39bfca20&scoped=true&"
import script from "./HistoryDetailDialog.vue?vue&type=script&lang=js&"
export * from "./HistoryDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDetailDialog.vue?vue&type=style&index=0&id=39bfca20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bfca20",
  null
  
)

export default component.exports